import React from 'react';
import Layout from './components/Layout';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import RecuperarContrasena2 from './components/RecuperarContrasena2';
import IniciarSesion from './components/IniciarSesion';
import "./styles/RecaptchaV3.css";

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Lfj5m0sAAAAAKHEJYCCIuBlN-KzBitGZhMxdcq1">
      <BrowserRouter>
        <Routes>
          {/* Ruta principal: Layout */}
          <Route path="/" element={<Layout />} />
          <Route path="/recuperar-contrasena" element={<RecuperarContrasena2 />} />
          <Route path="/login" element={<IniciarSesion />} />

        </Routes>
      </BrowserRouter>
    </GoogleReCaptchaProvider>
  );
}

export default App;